import { LayoutDashboard, ListChecks } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const ticketsNavigation: NavItem[] = [
  {
    to: '/tickets/dashboard',
    labelKey: 'nav.ticketsDashboard',
    group: 'nav.groups.support',
    icon: LayoutDashboard,
    permission: 'tickets.view',
  },
  {
    to: '/tickets',
    labelKey: 'nav.tickets',
    group: 'nav.groups.support',
    icon: ListChecks,
    permission: 'tickets.view',
  },
]
